<!-- @format -->
@let shouldShowRightHandRailYouMayAlsoLikeEnabled =
rightHandRailYouMayAlsoLikeEnabled() && !shouldShowPLA();
@let shouldShowRightHandRailCustomersAlsoBoughtEnabled =
rightHandRailCustomersAlsoBoughtEnabled() && !shouldShowPLA();

@if (isPLAPlaceholderEnabled()) {
    <!-- Please don't change this class list without regression testing PLA placeholder behavior -->
    <div [class]="plaPlaceholderClass">
        <common-progress-spinner diameter="40" strokeWidth="4" class="mx-auto hmf-p-xl hmf-mt-s">
        </common-progress-spinner>
    </div>
}

<!-- PLA Template -->
@if (shouldShowPLA()) {
<div class="hmf-mt-s">
    <div class="panel-content pla-body">
        <div [ngClass]="!isResonanceReady() ? 'pla-loading' : 'pla-content'">
            @if (shouldShowSpinner()) {
                <common-progress-spinner diameter="40" strokeWidth="4" class="mx-auto hmf-p-xl">
                </common-progress-spinner>
            }
            @if (
            !dataScienceRecommendationsEnabled() &&
            !newDataScienceRecommendationsEnabled() &&
            !newDataScienceRecommendationsEnabledNoPer()
            ) {
                <shared-components-product-recommendations [displayName]="'Browse our recommendations'"
                    filterBy="pdplanding_rr" [showViewMoreLink]="true" [imageSize]="'small'"
                    [showSkeletonLoading]="isLoadingStateRecsEnabled()">
                </shared-components-product-recommendations>
            } @else {
                <div [ngClass]="{ 'hmf-mx-s': isPLADSCarouselEnabled() }">
                    <shared-components-ds-product-recommendations [eCodeList]="[product().partNumber]"
                        [eventType]="'detail-page-view'" [containerID]="'PLA'" [placementID]="'others-you-may-like'"
                        [showViewAllLink]="true" [displayName]="!isPLADSCarouselEnabled() ? 'OUR TOP PICKS' : undefined"
                        [hideAddToCart]="
                                    newDataScienceRecommendationsEnabled() ||
                                    newDataScienceRecommendationsEnabledNoPer()
                                "
                        [hasGuidVisitor]="newDataScienceRecommendationsEnabledNoPer()"
                        [pageType]="'PDP'"
                        [isPLA]="true"
                        (recommendationsLoaded)="dataScienceRecommendationsLoaded.set($event)"
                        [showHeading]="!isPLADSCarouselEnabled()" [homefieldCarouselEnabled]="isPLADSCarouselEnabled()"
                        [showHeader]="isPLADSCarouselEnabled()"
                        [title]="isPLADSCarouselEnabled() ? 'Our Top Picks' : undefined"
                        (recommendationsErrored)="plaDataScienceRecommendationsErrored.set(true)"
                        [showSkeletonLoading]="isLoadingStateRecsEnabled()" [cardSize]="'medium'"
                        [smallLegacyMobileCard]="true">
                    </shared-components-ds-product-recommendations>
                </div>
            }
        </div>
    </div>
</div>
}

<pdp-exclusive-product-overlay
    [shouldShowPanel]="nikeLoginSuccess() && exclusiveType() === 'Nike' && isNikeConnectedEnabled()" [brand]="exclusiveType()">
</pdp-exclusive-product-overlay>

<div class="hmf-display-flex hmf-align-items-center hmf-justify-flex-start hmf-mb-s hmf-mt-s">
    @if (!isPLARequest()) {
        <pdp-back-to-search-results></pdp-back-to-search-results>
    }
    @if (browseBreadcrumbsEnabled()) {
        <pdp-breadcrumb class="hmf-pl-s"> </pdp-breadcrumb>
    }
</div>

@if (isRibbonGAMBannerEnabled()) {
    <!-- ATF GAM component instances should not be deferred -->
    <shared-components-google-ad-manager
        [data]="'top_ribbon_banner'"
        [showSponsoredLabel]="true"
        [enableTooltipSurvey]="enableTooltipSurvey()"
        [hasTopMargin]="false"
        [enableAdCarousel]="true"
        [isNarrowBanner]="false">
    </shared-components-google-ad-manager>
}

<div id="pdp-main-flex-container"
    class="hmf-display-flex hmf-flex-column hmf-flex-m-row hmf-align-items-start hmf-justify-content-between hmf-mb-xl hmf-mb-m-xxl"
    [ngClass]="{
		'smaller-grid-gap': !(
			shouldShowRightHandRailCustomersAlsoBoughtEnabled ||
			shouldShowRightHandRailYouMayAlsoLikeEnabled
		),
		'bigger-grid-gap':
			shouldShowRightHandRailCustomersAlsoBoughtEnabled ||
			shouldShowRightHandRailYouMayAlsoLikeEnabled
	}">
    <!-- Scenario 1: Resequenced (Mobile) - Title, star rating, pdp-promotions -->
    <div class="product-info-main-mobile hmf-display-md-none">
        @if (isMobile() === undefined || isMobile()) {
            @if (isBrandLinkEnabled() && brandLink()) {
                <div class="hmf-mx-s hmf-mx-m-0 hmf-mb-xxs">
                    <pdp-component-brand-link [brandLink]="brandLink()" [isMobile]="true"></pdp-component-brand-link>
                </div>
            }
            <div class="hmf-mx-s hmf-mx-m-0 hmf-pb-0 hmf-mb-xs hmf-mb-m-s">
                <h1 class="hmf-header-bold-s hmf-header-bold-lg-m" itemprop="name">
                    {{ product()?.name }}
                </h1>
            </div>
            @if (promotions() && isHighlyRatedReviewsEnabled()) {
                <pdp-promotion class="hmf-mx-s hmf-mx-m-0" [promotions]="promotions()"
                    [addFlexBox]="true" [isMobile]="isMobile()">
                </pdp-promotion>
            }
            @if (showExclusive()) {
                <pdp-exclusive-product-promo-message [brand]="exclusiveType()"></pdp-exclusive-product-promo-message>
            }
            @if (!reviewsOff()) {
                <div class="price-and-rating-stars">
                    <div class="rating-stars hmf-mx-s hmf-mx-m-0 hmf-display-flex hmf-align-items-center hmf-mb-m-s"
                    [ngClass]="{
                        'hmf-mb-xxs': isHighlyRatedReviewsEnabled(),
                        'hmf-mb-xs': !isHighlyRatedReviewsEnabled()
                    }">
                        <ng-container *ngTemplateOutlet="ratingStarsTemplate"></ng-container>
                    </div>
                </div>
                @if (isHighlyRatedReviewsEnabled()) {
                    <div class="hmf-mx-s hmf-mx-m-0">
                        <product-reviews-review-highly-rated-features (open)="openHighlyRatedFeatures()" />
                    </div>
                }
            }
        }
        @if (isMobile() === undefined || (isMobile() && !isHighlyRatedReviewsEnabled())) {
            @if (promotions()) {
                <pdp-promotion class="hmf-mx-s hmf-mx-m-0" [promotions]="promotions()"
                    [addFlexBox]="true" [isMobile]="isMobile()">
                </pdp-promotion>
            }
        }
    </div>

    <div class="hmf-display-flex hmf-flex-column hmf-flex-m-row full-width" [ngClass]="{
        'smaller-grid-gap': !(
            shouldShowRightHandRailCustomersAlsoBoughtEnabled ||
            shouldShowRightHandRailYouMayAlsoLikeEnabled
        ),
        'rail-rec-spacing':
            shouldShowRightHandRailCustomersAlsoBoughtEnabled ||
            shouldShowRightHandRailYouMayAlsoLikeEnabled
    }">
        <div id="pdp-upper-left"
            class="hmf-flex flex-item hmf-align-self-start grid-gallery flex-item-left hmf-position-lg-sticky image-viewer-mobile-no-padding image-viewer-ipad-view"
            [ngClass]="{
				'pl-image-container': chain?.chainIdentifierAbbr === 'pl',
				'hmf-px-m-m hmf-mr-l-s hmf-mr-xl-l': !(
					shouldShowRightHandRailCustomersAlsoBoughtEnabled ||
					shouldShowRightHandRailYouMayAlsoLikeEnabled
				)
			}">
            <!-- Image Viewer -->
            <ng-container *ngTemplateOutlet="newImageViewer"></ng-container>
        </div>
        <!-- end #pdp-upper-left -->

        <div id="pdp-upper-right"
            class="flex-item grid-gallery flex-item-right hmf-position-lg-sticky hmf-align-self-start hmf-pt-m-0 hmf-pt-s-s"
            [ngClass]="{
				'pl-info-container': chain?.chainIdentifierAbbr === 'pl'
			}">
            <!-- Scenario 1: Resequenced (Desktop) - Title, star rating, pdp-promotions -->
            <div class="product-info-main-desktop hmf-display-none hmf-display-md-block">
                @if (!isMobile()) {
                    @if (isBrandLinkEnabled() && brandLink()) {
                        <div class="hmf-mx-s hmf-mx-m-0 hmf-mb-xxs">
                            <pdp-component-brand-link [brandLink]="brandLink()" [isMobile]="false"></pdp-component-brand-link>
                        </div>
                    }
                    <div class="hmf-pb-0 hmf-mb-xs hmf-mb-m-s hmf-mx-s hmf-mx-m-0">
                        <h1 class="hmf-header-bold-m hmf-header-bold-lg-m" itemprop="name">
                            {{ product()?.name }}
                        </h1>
                    </div>
                    @if (promotions() && isHighlyRatedReviewsEnabled()) {
                        <pdp-promotion class="hmf-mx-s hmf-mx-m-0"
                            [promotions]="promotions()" [addFlexBox]="true" [isMobile]="isMobile()">
                        </pdp-promotion>
                    }
                     @if (!reviewsOff()) {
                        <div class="price-and-rating-stars">
                            <div class="rating-stars hmf-mt-0 hmf-display-flex hmf-align-items-center" [ngClass]="{
                                'in-stock-rating-stars':
                                product()?.disableSkuLevelPricing || product()?.colorAttributeBuckets.length <= 1,
                                'hmf-mb-xxs': isHighlyRatedReviewsEnabled(),
                                'hmf-mb-m-s': !isHighlyRatedReviewsEnabled() && (promotions() || showExclusive()),
                                'hmf-mb-m-m': !isHighlyRatedReviewsEnabled() && !promotions() && !showExclusive()
                            }">
                                <ng-container *ngTemplateOutlet="ratingStarsTemplate"></ng-container>
                            </div>
                        </div>
                    }
                    @if (showExclusive()) {
                        <pdp-exclusive-product-promo-message [brand]="exclusiveType()"></pdp-exclusive-product-promo-message>
                    }
                    @if (!reviewsOff() && isHighlyRatedReviewsEnabled()) {
                        <div class="hmf-mx-s hmf-mx-m-0">
                            <product-reviews-review-highly-rated-features (open)="openHighlyRatedFeatures()" />
                        </div>
                    }
                }
                @if (!isMobile() && !isHighlyRatedReviewsEnabled()) {
                    @if (promotions()) {
                        <pdp-promotion class="hmf-mx-s hmf-mx-m-0" [promotions]="promotions()"
                            [addFlexBox]="true" [isMobile]="isMobile()">
                        </pdp-promotion>
                    }
                }
            </div>

            @if (
                product()?.disableSkuLevelPricing ||
                product()?.colorAttributeBuckets.length <= 1 || colorSelectionPanelEnabled() ) {
                <div class="hmf-display-flex hmf-mr-s hmf-mr-m-0 price-and-rating-stars" [ngClass]="{
					'hmf-mt-m-xxxs': !isHighlyRatedReviewsEnabled()
				}">
                    <pdp-price class="price-container hmf-mb-xxs"
                        [updatePriceBasedOnSelectedColor]="colorSelectionPanelEnabled()">
                    </pdp-price>
                </div>
            }

            <!-- Custom Product Button -->
            @if (product()?.customSeoUrl && !dropdownAttributesEnabled()) {
                <pdp-custom-components-customize-product-button [customSeoUrl]="product()?.customSeoUrl">
                </pdp-custom-components-customize-product-button>
            }

            <!-- INSTORE ONLY ALERT MESSAGE -->
            @if (inStoreOnlyFulfillmentScenario()) {
                <div class="hmf-my-m hmf-mx-s hmf-mx-md-0">
                    <hmf-alert-banner
                        type="warn"
                        title="In-Store Purchase Only"
                        message="Please check your local store for availability. "
                        link="/s/stores"
                        linkTitle="Find A Store"
                    />
                </div>
            }

            <pdp-attributes-components-attributes class="hmf-mx-s hmf-mx-m-0"
                [nonColorQueryParams]="product().actualAdditionalQueryParams" [skuIdQueryParam]="skuIdQueryParam()"
                [disableSkuLevelPricing]="product().disableSkuLevelPricing"
                [colorAttributeBuckets]="product()?.colorAttributeBuckets"
                [alternativeInStockRecsEnabled]="alternativeInStockRecsEnabled()" [isApparelOrFootwear]="isApparelOrFootwear()"
                [colorSelectionPanelEnabled]="colorSelectionPanelEnabled()"
                [sizeSelectionPanelEnabled]="sizeSelectionPanelEnabled()"
                [dropdownAttributesEnabled]="dropdownAttributesEnabled()" [customSeoUrl]="product()?.customSeoUrl"
                [isLoadingStateRecsEnabled]="isLoadingStateRecsEnabled()"
                [isMobile]="isMobile()"></pdp-attributes-components-attributes>

            @if (warrantiesEnabled() && isProductWarrantyEligible()) {
                <pdp-component-warranty-button class="hmf-mt-s hmf-display-block hmf-mx-s hmf-mx-m-0">
                </pdp-component-warranty-button>
            }

            <!-- GTGT -->
            @defer (when lazyHomrGTGTContent()) {
                <pdp-gtgt-content [gtgtContent]="lazyHomrGTGTContent()"></pdp-gtgt-content>
            }

            <!-- Start Fulfillment Re-write components -->
            @if (
                !shouldNikeConnectedButtonBeDisplayed() &&
                !shouldGoldExclusiveButtonBeDisplayed() &&
                (inStoreOnlyFulfillmentScenario()) !== true
                ) {
                <pdp-notify-me-panel></pdp-notify-me-panel>
                @if (isComingSoon() === false) {
                    <div id="pdp-fullfilment-button-container"
                        class="hmf-display-flex hmf-flex-row hmf-pt-0 hmf-mx-s hmf-mx-m-0 hmf-mt-l hmf-mt-md-xl fulfillment-button-container">
                        @if (!isBOPISLOnly()) {
                            <pdp-feature-ship-to-me-button ngSkipHydration [skuEDDEnabled]="skuEDDEnabled()">
                            </pdp-feature-ship-to-me-button>
                        }
                        <pdp-feature-in-store-pickup-button ngSkipHydration
                            [nearbyStoresButtonEnabled]="nearbyStoresButtonEnabled()"></pdp-feature-in-store-pickup-button>
                        @if (sameDayDeliveryEnabled() && !isBOPISLOnly()) {
                            <pdp-feature-same-day-delivery-button ngSkipHydration>
                            </pdp-feature-same-day-delivery-button>
                        }
                    </div>
                    <div id="pdp-fulfillment-subtext-container" class="hmf-mt-s">
                        <pdp-feature-fulfillment-button-subtext>
                        </pdp-feature-fulfillment-button-subtext>
                    </div>
                }
                @if (
                    exclusiveType() &&
                    (isNikeConnectedEnabled() || isGoldExclusiveEnabled()) &&
                    isAuthenticatedAndExclusiveUnlocked()
                    ) {
                    <div class="hmf-w-100 hmf-mt-m">
                        <pdp-exclusive-product-info [brand]="exclusiveType()" [accessState]="'unlocked'">
                        </pdp-exclusive-product-info>
                    </div>
                }
                <div class="hmf-px-s hmf-px-md-0 hmf-mt-l">
                    <pdp-feature-add-to-cart-section
                        class="hmf-display-flex hmf-justify-content-flex-end hmf-flex-wrap hmf-flex-column"
                        [isSingleSkuProduct]="product().skus?.length === 1"
                        [ecode]="product().partNumber"></pdp-feature-add-to-cart-section>
                </div>
            }

            @if (shouldNikeConnectedButtonBeDisplayed()) {
                <pdp-exclusive-product-info class="hmf-mb-m" [brand]="exclusiveType()" [accessState]="'locked'">
                </pdp-exclusive-product-info>
                <shared-component-exclusive-product-panel [brand]="exclusiveType()" [ctaType]="exclusiveCTAType()"
                    [accessState]="'locked'">
                </shared-component-exclusive-product-panel>
            }

            @if (shouldGoldExclusiveButtonBeDisplayed()) {
                <shared-component-exclusive-product-panel [brand]="exclusiveType()" [ctaType]="exclusiveCTAType()"
                    [accessState]="'locked'" [infoOnly]="true">
                </shared-component-exclusive-product-panel>
                @if (exclusiveCTAType() === 'locked') {
                    <scorecard-gold-member-status class="hmf-mt-s"></scorecard-gold-member-status>
                }
                <div class="hmf-px-s hmf-px-md-0">
                    @if (exclusiveCTAType() !== 'unlocked') {
                        <button hmf-button
                            variant="primary"
                            size="large"
                            class="hmf-mt-m full-width"
                            [disabled]="exclusiveCTAType() === 'locked'"
                            (click)="login()">
							{{ exclusiveCTAType() === 'locked' ? 'ScoreCard Gold Exclusive' : 'Sign In' }}
						</button>
                    }
                </div>
            }

            <!-- In Store only - Ecode level -->
            @if (inStoreOnlyFulfillmentScenario()) {
                <button hmf-button
                    variant="primary"
                    aria-label="In-Store Only"
                    id="pdp-instore-only"
                    class="hmf-w-100"
                    [disabled]="true"
                    text="In-Store Only"></button>
            }

            @if (
                alternativeInStockRecsEnabled() &&
                shouldShowOutOfStockRecs() &&
                !shouldShowAlternativeInStockRecs() &&
                nearbyStoreCount() > 0
                ) {
                <shared-components-product-recommendations class="hmf-mt-l hmf-mt-m-xl"
                    [displayName]="'Try These Instead'" filterBy="skuoos_rr"
                    [showViewMoreLink]="false" [isOOSRecommendations]="true"
                    [showSkeletonLoading]="isLoadingStateRecsEnabled()">
                </shared-components-product-recommendations>
            }

            <!-- Side Panels have to be declared inline with element calling it or above all other elements-->
            <pdp-add-to-cart-success [preOrderEnabled]="preOrderEnabled()" [product]="product()"
                [newDataScienceRecommendationsEnabledNoPer]="
                        newDataScienceRecommendationsEnabledNoPer()
                    " ngSkipHydration>
            </pdp-add-to-cart-success>

            @if (isScorerewardsMessageEnabled()) {
                <scorecard-score-reward class="hmf-mx-s hmf-mx-m-0 hmf-mt-s"></scorecard-score-reward>
            }

            @if (product().buyable) {
                <pdp-bnpl class="hmf-mx-s hmf-mx-m-0" [productPrice]="product().prices"
                    [isProductPaypalEligible]="product().isPayPalEligible">
                </pdp-bnpl>
            }

            @if (readyForNextRoundAddOnsEnabled()) {
                <pdp-ready-for-next-round-add-ons></pdp-ready-for-next-round-add-ons>
            }

            @defer (when scoreCardData()) {
                <scorecard-scorecard-points [SCORECARD_DATA]="scoreCardData()"></scorecard-scorecard-points>
            }

            <!-- In-Store Services -->

            @defer (when lazyHomrInStoreServicesContent()) {
                <pdp-in-store-services [homrInStoreServicesContent]="
                                lazyHomrInStoreServicesContent()
                            "></pdp-in-store-services>
            }

            @if (sizeandFitSummary()?.length !== 0) {
                <div class="hmf-display-flex hmf-flex-wrap hmf-mt-m">
                    <pdp-highlights [items]="sizeandFitSummary()"> </pdp-highlights>
                </div>
            }

            <!-- Homr Sliders -->
            <div [ngClass]="{ 'pdp-content-width hmf-mb-xl': homrStatSliderLoaded() }">
                @defer (when homrStatSliderLoaded()) {
                    <pdp-homr-sliders [productStatsSlider]="homrSliderData()"></pdp-homr-sliders>
                }
            </div>

            @defer (when homrTextLinkContent()) {
                <pdp-homr-text-link [homrContent]="homrTextLinkContent()" [homrSpotName]="'freeShipMessage'"></pdp-homr-text-link>
            }

            @if (hasReturnPolicy()) {
                <pdp-return-policy></pdp-return-policy>
            }

            <pdp-component-shipping [productStyle]="product()" [preOrderEnabled]="preOrderEnabled()">
            </pdp-component-shipping>

            <!-- Reviews Highlight -->
            @if (!reviewsOff() && newReviews() && !reviewsMVPRetest() && (!useProductCatalogRatingData() || ratingCount())) {
                <product-reviews-highlight-container
					[productIdentifier]="product()?.partNumber"
					[ratingValue]="useProductCatalogRatingData() ? ratingValue() : null"
					[ratingCount]="useProductCatalogRatingData() ? ratingCount() : null"
				> </product-reviews-highlight-container>
            }
        </div>
    </div>
    <!-- end #pdp-upper-right -->
    @if (
        (isDesktopExtraLarge() === undefined || isDesktopExtraLarge()) &&
        (shouldShowRightHandRailCustomersAlsoBoughtEnabled ||
        shouldShowRightHandRailYouMayAlsoLikeEnabled)
        ) {
        <product-recommendations-components-product-recommendations-rail
            class="hmf-display-none hmf-display-l-block"
            [title]="shouldShowRightHandRailCustomersAlsoBoughtEnabled
                            ? 'Customers Also Bought'
                            : 'You May Like'
                    "
            [schemeName]="shouldShowRightHandRailCustomersAlsoBoughtEnabled ? 'product2_rr' : 'product_rr'">
        </product-recommendations-components-product-recommendations-rail>
    }
</div>
<!-- end #pdp-main-flex-container (upper portion)-->

<div id="pdp-lower-flex-container" class="pdp-lower-flex-container hmf-display-flex hmf-flex-column">
    <!-- homR banner -->
    <div class="pdp-content-width margin-auto">
        @defer (when lazyHomrBannerContent()) {
            <pdp-homr-banner [data]="lazyHomrBannerContent()"></pdp-homr-banner>
        }
    </div>

    <pdp-product-info-specs
		class="hmf-mb-m"
		[backgroundImage]="chain?.chainIdentifierAbbr === 'pl' ? `url('assets/image/Background_PL_PDP.png')` : undefined"
		[product]="product()">
        <ng-container *ngTemplateOutlet="productInfo"></ng-container>
        <ng-container *ngTemplateOutlet="productSpecs"></ng-container>
        @if (isUtahLawLabelAccordionEnabled() && textileLabelInfo(); as textileLabel) {
            <pdp-textile-label [textileLabel]="textileLabel"> </pdp-textile-label>
        }
    </pdp-product-info-specs>

    <ng-template #productInfo>
        <!-- Product Information -->
        <pdp-product-description ngSkipHydration class="pdp-content-width margin-auto" [product]="product()"
            [resolvedSkuID]="resolvedSkuPartNumber()" [comingSoonEndDate]="resolvedSku()?.comingSoonEndDate"
            [sustainablityIconsEnabled]="sustainablityIconsEnabled()" [infoSummaryEnabled]="infoSummaryEnabled()">
        </pdp-product-description>
    </ng-template>

    <ng-template #productSpecs>
        <!-- Tech Specs -->
        @if (product()?.auxDescription1) {
            <pdp-tech-specs class="pdp-content-width margin-auto" [techSpecs]="product()?.auxDescription1">
            </pdp-tech-specs>
        }
    </ng-template>
    <!-- Social Images Carousel Below Product Info -->
    @if (!reviewsOff() && isSocialImagesEnabled() && isSocialImageBelowProductInfoEnabled()) {
        <pdp-social-content-images-carousel></pdp-social-content-images-carousel>
    }

    @if (styliticsShopTheSetEnabled()) {
        @defer {
            <pdp-component-stylitics-shop-the-set [ecode]="product().partNumber"
                [selectedColorAttribute]="selectedColorAttribute()"></pdp-component-stylitics-shop-the-set>
        }
    }

    <!-- Stylitics Component -->
    @if (styliticsEnabled()) {
        <pdp-component-stylitics [product]="product()" [selectedColorAttribute]="selectedColorAttribute()"
            [shopTheLookEnabled]="styliticsShopTheLookEnabled()" [styliticsEnabled]="styliticsEnabled()"
            [styliticsMnMEnabled]="styliticsMnMEnabled()">
        </pdp-component-stylitics>
    }

   <!-- Frequently Bought Together -->
    @defer (when fbtRecommendationStatus().displayable) {
        @if (frequentlyBoughtTogetherKillSwitchEnabled() && fbtRecommendationStatus().displayable && !isComingSoon()) {
			<pdp-frequently-bought-together
				[product]="product()"
				[selectedColorAttribute]="selectedColorAttribute()"
			></pdp-frequently-bought-together>
        }
    } @placeholder {
        <!-- Only show skeleton loader when we know we'll have valid FBT data -->
        @if (fbtRecommendationStatus().displayable) {
             <div class="pdp-content-width margin-auto">
                <div class="hmf-display-flex hmf-flex-row hmf-justify-content-center hmf-gap-l hmf-w-100 hmf-mb-xl">
                    <pdp-carousel-skeleton-loader class="hmf-flex-1 hmf-w-100"></pdp-carousel-skeleton-loader>
                    <pdp-carousel-skeleton-loader class="hmf-flex-1 hmf-w-100"></pdp-carousel-skeleton-loader>
                    <pdp-carousel-skeleton-loader class="hmf-flex-1 hmf-w-100"></pdp-carousel-skeleton-loader>
                </div>
            </div>
        }
    }

    @defer (when homrWireSpot()) {
        <pdp-homr-wire-spot [lazyLoadImages]="true"></pdp-homr-wire-spot>
    }

    <div>
        <!-- 3D Sketchfab -->
        @defer (when sketchfab3DData()) {
            <div class="pdp-content-width hmf-m-auto hmf-mb-xl">
                <pdp-sketchfab-3d-imagery [data]="sketchfab3DData()"></pdp-sketchfab-3d-imagery>
            </div>
        }

        <!-- BV Reveal Static Content to be injected here-->
        @if (isShoppableBVImageEnabled()) {
            <pdp-bv-shoppable-image class="pdp-content-width margin-auto hmf-mb-xl" />
        }

        <!-- Syndigo Information -->
        @if (syndigoEnabled()) {
            <pdp-component-syndigo class="pdp-content-width margin-auto hmf-mb-xl" [product]="product()"
                [syndigoEnabled]="syndigoEnabled()">
            </pdp-component-syndigo>
        }

        <!-- Homr Rich Content -->
        <div class="pdp-content-width hmf-m-auto hmf-mb-xl">
            @defer (when homrRichContent()) {
                <pdp-homr-rich-content [homrRichContent]="homrRichContent()" [product]="product()"></pdp-homr-rich-content>
            }
        </div>
    </div>
    <!-- End container for background image check for PL -->

    @if (shouldShowExclusiveContentAd()) {
        <pdp-exclusive-product-ad [brand]="brand()"></pdp-exclusive-product-ad>
    }

    <!-- Compare Chart -->
	@if (isComparisonTableEnabled() && (compareDataStatus().displayable || isLoadingStateRecsEnabled())) {
		@defer {
			<pdp-templates-compare-section
				[currentProduct]="product()"
				[currentProductSelectedColor]="selectedColorAttribute()"
				wrapperClasses="hmf-mb-xl"
			></pdp-templates-compare-section>
		}
	}

    <!-- Certona Recommendations 'You May Also Like' -->
    <div id="product_rr" class="hmf-mb-xl hmf-mx-s">
        @if (!shouldShowRightHandRailYouMayAlsoLikeEnabled || !isDesktopExtraLarge()) {
            <shared-components-product-recommendations [displayName]="'You May Also Like'"
													   [showQVButtons]="false" filterBy="product_rr" [showViewMoreLink]="true"
													   [homefieldCarouselEnabled]="true" [showSkeletonLoading]="isLoadingStateRecsEnabled()">
            </shared-components-product-recommendations>
        }
    </div>

    <!-- Criteo Sponsored Products (Must-Have Picks) -->
    @if (showSponsoredProducts()) {
        <div id="product1_rr" class="hmf-mx-s">
            <shared-components-product-recommendations displayName="Must-Have Picks" [sponsored]="true"
                [ecode]="product()?.partNumber" [homefieldCarouselEnabled]="true"
                [showSkeletonLoading]="isLoadingStateRecsEnabled()" [criteoViewItemMetadata]="criteoViewItemMetadata()">
            </shared-components-product-recommendations>
        </div>
    }
    <!-- Social Images Carousel Above Reviews -->
    @if (!reviewsOff() && isSocialImagesEnabled() && isSocialImageAboveReviewsEnabled()) {
        <pdp-social-content-images-carousel></pdp-social-content-images-carousel>
    }
    <!-- BV Reviews Column -->
    @if (!reviewsOff() && !newReviews() && !reviewsMVPRetest() && (!useProductCatalogRatingData() || ratingCount())) {
        <product-reviews-bv-reviews class="pdp-content-width margin-auto hmf-mb-xl"
            [productIdentifier]="product()?.partNumber">
        </product-reviews-bv-reviews>
    }

    <!-- Reviews Highlight -->
    @if (!reviewsOff() && reviewsMVPRetest() && (!useProductCatalogRatingData() || ratingCount())) {
		<product-reviews-highlight-container
			class="pdp-content-width margin-auto hmf-mb-xl"
			[productIdentifier]="product()?.partNumber"
			[ratingValue]="useProductCatalogRatingData() ? ratingValue() : null"
			[ratingCount]="useProductCatalogRatingData() ? ratingCount() : null"
		> </product-reviews-highlight-container>
    }

    <!-- BV Questions and Answers Column -->
    @if (!reviewsOff() && !newReviews()) {
        <product-reviews-questions-and-answers-v2 class="pdp-content-width margin-auto hmf-mb-xl"
            [productIdentifier]="product()?.partNumber">
        </product-reviews-questions-and-answers-v2>
    }

    <!-- Certona Recommendations 'Customers Also Bought' -->
    @if (!shouldShowRightHandRailCustomersAlsoBoughtEnabled || !isDesktopExtraLarge()) {
        <div id="sponsored_products" class="hmf-mb-xl hmf-mx-s">
            <shared-components-product-recommendations [displayName]="'Customers Also Bought'"
													   filterBy="product2_rr" [showViewMoreLink]="true" [showQVButtons]="false"
													   [homefieldCarouselEnabled]="true" [showSkeletonLoading]="isLoadingStateRecsEnabled()">
            </shared-components-product-recommendations>
        </div>
    }

    <!-- Certona Recommendations 'Recently Viewed' -->
    <div id="product1_rr" class="hmf-mb-xl hmf-mx-s">
        <shared-components-product-recommendations [displayName]="'Recently Viewed'"
												   filterBy="product1_rr" [showViewMoreLink]="false" [showQVButtons]="false"
												   [homefieldCarouselEnabled]="true" [showSkeletonLoading]="isLoadingStateRecsEnabled()">
        </shared-components-product-recommendations>
    </div>

    <!-- AEM content - only on PL in Prod -->
    @if (enableAEMContent()) {
        <pdp-aem-articles class="hmf-p-0" [article]="'Default'">
        </pdp-aem-articles>
    }

    <pdp-component-snackbar></pdp-component-snackbar>

    @if (product()?.pdpSeoUrl && isPDPProTipsEnabled()) {
        <shared-component-pro-tips [category]="product().pdpSeoUrl"> </shared-component-pro-tips>
    }

    <div>
        @if (pdpGoogleAdManagerEnabled()) {
            <shared-components-google-ad-manager [data]="'bottom_banner'" [showSponsoredLabel]="true"
                [enableTooltipSurvey]="enableTooltipSurvey()">
            </shared-components-google-ad-manager>
        }
    </div>
</div>
<!-- end #pdp-lower-flex-container -->

<!-- RESEQUENCING TEMPLATES -->
<!-- Templates image viewer (gallery/carousel) -->
<ng-template #newImageViewer>
    <div class="hmf-display-none hmf-display-md-block">
        @if (isMobile() !== undefined) {
            <pdp-product-image-viewer class="hmf-px-s hmf-px-m-0" [eCode]="product()?.partNumber" [product]="product()"
                [productName]="product()?.name" [catalogEntryTypeCode]="'ProductBean'" [imageBadge]="product()?.badge || ''"
                [swatchColor]="selectedColorAttribute()"
                [shouldHaveBorder]="chain?.chainIdentifierAbbr === 'pl'"
                [killSwitches]="killSwitches()"></pdp-product-image-viewer>
        } @else {
            <pdp-carousel-skeleton-loader id="skeleton"></pdp-carousel-skeleton-loader>
        }
    </div>
    <div class="hmf-display-md-none">
        <!-- Mobile Carousel View -->
        @if (useAboveTheFoldMobileContainer()) {
            <ng-container #targetAboveTheFoldViewRef></ng-container>
            <div [ngClass]="{
                        'carousel-initial-container': !wasAboveTheFoldContentLoaded(),
                        'carousel-badge': product()?.badge
                    }"></div>
        } @else {
            <pdp-product-image-carousel [location]="templateName" [product]="product()"
                [chainIdentifierAbbr]="chain?.chainIdentifierAbbr"
                [swatchColor]="selectedColorAttribute()"></pdp-product-image-carousel>
        }
        @if (isJumpLinkEnabled() && productHasColorWithStylitics()) {
            <div class="hmf-mt-s hmf-mb-xxs hmf-display-flex hmf-justify-content-center">
                <pdp-component-stylitics-jumplink [disabled]="!styliticsWidgetShown()"
                    [isMobile]="true"></pdp-component-stylitics-jumplink>
            </div>
        }
    </div>
</ng-template>

<ng-template #ratingStarsTemplate>
    <product-reviews-rating-summary-stars
        [class.hmf-mr-xxs]="useProductCatalogRatingData()"
        [productPartNumber]="product()?.partNumber"
        [isDrawerAvailable]="newReviews()"
        [ratingCount]="ratingCount()"
        [ratingValue]="ratingValue()"
        [useProductCatalogRatingData]="useProductCatalogRatingData()"
    ></product-reviews-rating-summary-stars>
    @if (isReviewImgPlacementEnabled()) {
        <product-reviews-multimedia-count></product-reviews-multimedia-count>
    }
	@if (isSocialImagesEnabled()) {
		<pdp-hot-on-social-button [seoUrl]="product()?.pdpSeoUrl"></pdp-hot-on-social-button>
	}
</ng-template>

<!-- Display highly rated for modal to have z-index priority over other elements -->
@if (!reviewsOff() && isHighlyRatedReviewsEnabled()) {
    <product-reviews-review-highly-rated-features-modal #highlyRatedFeaturesModal>
    </product-reviews-review-highly-rated-features-modal>
}

<pdp-component-app-snackbar></pdp-component-app-snackbar>
